export default {"src":"/_next/static/media/logo-tree.394ff4ed.svg","height":109,"width":102,"blurWidth":0,"blurHeight":0};